import React from 'react';
import { NumberType } from '@/presentation/components/form/components/select-number';
import { IssueTrendAnalysis } from '@/presentation/components/issue-trend-analysis';
import { PerIssueTrendAnalysis } from '@/presentation/components/per-issue-trend-analysis';

import { IssueMetricType } from '@/proto/common';
import { IssueType } from '@/proto/issue';
import { MetricSubType, MetricType, TimeType } from '@/proto/metric';

export interface BatchTrendProps {
  issueType: IssueType;
  metricType: MetricType;
  token: string;
  headToken: string;
  pgId: string;
  timeWindow?: TimeType;
  startDateStr?: string;
  endDateStr?: string;
  launchDuration?: NumberType;
  searchParams?: Record<string, any>;
  queryCompareToken?: (params: Record<string, any>) => Promise<string>;
}
export const BatchTrend = (props: BatchTrendProps) => {
  const { searchParams, issueType, metricType, headToken, pgId, queryCompareToken, timeWindow } = props;

  if ([IssueType.ISSUE_TYPE_LAG].includes(issueType)) {
    const tabConfigs = [
      {
        key: IssueMetricType.ISSUE_METRIC_REPORT_COUNT,
        name: '发生次数',
        isTotalSize: false,
      },
      {
        key: IssueMetricType.ISSUE_METRIC_DEVICE_COUNT,
        name: '影响设备数',
        isTotalSize: false,
      },
      {
        key: IssueMetricType.ISSUE_METRIC_USER_COUNT,
        name: '影响用户数',
        isTotalSize: false,
      },
    ];
    return <PerIssueTrendAnalysis
      pgId={pgId}
      showTitle={false}
      showSwitch={false}
      showDownload={false}
      issueType={issueType}
      token={headToken}
      headToken={headToken}
      timeWindow={timeWindow ?? TimeType.MINUTE5 as any}
      searchParams={searchParams}
      cardProps={{
        bordered: false,
      }}
      tabConfigs={tabConfigs}
    />;
  }
  return <IssueTrendAnalysis
    cardProps={{
      bordered: false,
      bodyStyle: { padding: 0 },
    }}
    showTools={false}
    includeMetrics={[
      MetricSubType.SUB_TYPE_COUNT,
      MetricSubType.SUB_TYPE_DEVICE_UV,
      MetricSubType.SUB_TYPE_USER_UV,
    ]}
    endDateStr={searchParams?.endDateStr}
    startDateStr={searchParams?.startDateStr} launchDuration={searchParams?.launchDuration}
    issueType={issueType}
    metricType={metricType}
    token={headToken}
    timeWindow={searchParams?.timeWindow || timeWindow}
    headToken={headToken}
    pgId={pgId}
    searchParams={searchParams}
    queryCompareToken={queryCompareToken}
    defaultTab={{
      unit: '',
      tabKey: MetricSubType.SUB_TYPE_COUNT,
      tabName: '发生次数',
    }}
  />;
};
